{
  "qwerty": [
    "1234567890-\\",
    "QWERTYUIOP ",
    "ASDFGHJKL ",
    "ZXCVBNM,."
  ]
}
